import { Box, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import { daysDiff } from '@/helpers/date/dateHelpers.js';
import { getAdStatusColor, getAdStatusLabel, isAdStatusOngoing } from '@/constants/AdStatus.js';
import { marketingStyles } from '@/themes/commonStyles/marketing';

const StyledAdsCampaignsPeriodItem = styled(Box)(marketingStyles.adsCampaignsPeriodItem);

const calculateElapsedDays = startDate => {
    if (!startDate) return 0;
    const today = new Date();
    return daysDiff(today, startDate);
};

const getStatusColor = status => getAdStatusColor(status);

export const AdsCampaignsPeriodItem = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;

    const startDate = record?.startDate ? new Date(record.startDate) : null;
    const endDate = record?.endDate ? new Date(record.endDate) : null;

    const totalDays = startDate && endDate ? daysDiff(endDate, startDate) : 0;
    const elapsedDays = calculateElapsedDays(startDate);
    const isOngoing = isAdStatusOngoing(record?.status);

    const formatDate = (date, formatPattern) => (date ? format(date, formatPattern, { locale: pl }) : '—');
    const startDateText = formatDate(startDate, 'dd.MM');
    const endDateText = formatDate(endDate, 'dd.MM.yyyy');

    const daysText = isOngoing ? `${elapsedDays}/${totalDays}` : totalDays;

    const statusLabel = getAdStatusLabel(record?.status, translate);

    return (
        <StyledAdsCampaignsPeriodItem className='ads-campaigns-period-item'>
            <Chip label={statusLabel} size='small' style={{ backgroundColor: getStatusColor(record?.status) }} />
            {record?.isPermanent
                ? translate('resources.adsCampaign.labels.permanentAd')
                : `${startDateText} - ${endDateText} (${daysText} ${translate('analytics.common.days')})`}
        </StyledAdsCampaignsPeriodItem>
    );
};

AdsCampaignsPeriodItem.propTypes = {
    record: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        status: PropTypes.string,
        isPermanent: PropTypes.bool,
    }),
};
